// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlayCircleFilledSvg from "@ant-design/icons-svg/es/asn/PlayCircleFilled";
import AntdIcon from '../components/AntdIcon';

var PlayCircleFilled = function PlayCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleFilledSvg
  }));
};

PlayCircleFilled.displayName = 'PlayCircleFilled';
export default React.forwardRef(PlayCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PlayCircleFilled.js
// module id = 1577
// module chunks = 0